import gql from 'graphql-tag';

export const VERIFY_ORGANIZATION_NAME = gql`
  query verifyOrganizationName($input: VerifyOrganizationNameInput!) {
    verifyOrganizationName(input: $input)
  }
`;

export type verifyOrganizationNameVariables = {
  input: {
    name: string;
  };
};

export type verifyOrganizationNameMutation = {
  verifyOrganizationName: boolean;
};
